<template>
  <div class="card card-hover text-center flex-grow-1">
    <div
      class="settings-card-visual d-flex align-items-center justify-content-center p-3"
    >
      <div
        v-if="showIcons"
        class="settings-card-icon bg-primary-subtle rounded-4 d-flex align-items-center justify-content-center"
      >
        <ImageBlob
          v-if="tool.data.icon"
          class="settings-card-icon-image w-100 h-100 p-3"
          :imagePath="tool.data.icon"
        />
        <font-awesome-icon
          v-else
          :icon="['far', 'face-confused']"
          size="2x"
          class="text-primary"
        />
      </div>
      <ImageBlob
        v-else
        class="settings-card-image w-100 overflow-hidden"
        :imagePath="tool.data.image"
      />
    </div>
    <div class="card-body d-flex flex-column justify-content-end">
      <div class="card-text">
        <h4>{{ tool.data.name }}</h4>
        <ul class="list-group list-group-flush">
          <li
            class="list-group-item list-group-item-action"
            v-if="isSuperAdmin"
            @click="$emit('settings', tool)"
          >
            {{ $t("settings.settings") }}
          </li>
          <li
            class="list-group-item list-group-item-action"
            v-if="isSuperAdmin"
            @click="$emit('delete', tool.id)"
          >
            {{ $t("settings.delete") }}
          </li>
          <li
            class="list-group-item list-group-item-action"
            v-if="isSuperAdmin || isAdmin"
            @click="$emit('users', tool.id)"
          >
            {{ $t("settings.user") }} ({{ tool.data?.users?.length || 0 }})
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import ImageBlob from "../smallComponents/ImageBlob.vue";

  export default {
    name: "ToolCard",
    components: {
      ImageBlob,
    },
    props: {
      tool: {
        type: Object,
        required: true,
      },
      showIcons: {
        type: Boolean,
        default: false,
      },
      isSuperAdmin: {
        type: Boolean,
        default: false,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["settings", "delete", "users"],
  };
</script>

<style scoped>
  .card-hover {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .card-hover:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
    z-index: 1;
  }

  .settings-card-visual {
    min-height: 10rem;
  }

  .settings-card-image {
    height: 10rem;
  }

  .settings-card-image :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .settings-card-icon {
    width: 6rem;
    height: 6rem;
  }

  .settings-card-icon-image :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
